module.exports = __webpack_public_path__ + "static/media/user.ac03058f.png";